import { Grid, List } from "react-feather";
import { useAppDispatch } from "../../../../../../ReduxToolkit/Hooks";
import { setColView, setListView } from "../../../../../../ReduxToolkit/Reducers/ECommerce/FilterSlice";
import { Href } from "../../../../../../Constants/Constants";

export const GridAndListView = () => {
  const dispatch = useAppDispatch();
  const gridLayout = () => {
    dispatch(setListView(false));
    dispatch(setColView("col-xl-3 col-lg-4 col-sm-6"));
  };

  return (
    <>
      <div className="square-product-setting d-inline-block">
        <a className="icon-grid grid-layout-view" href={Href} onClick={gridLayout}>
          <Grid />
        </a>
      </div>
      <div className="square-product-setting d-inline-block">
        <a className="icon-grid m-0 list-layout-view" href={Href} onClick={() => dispatch(setListView(true))}>
          <List />
        </a>
      </div>
    </>
  );
};
